<template>
  <popup ref="popup" :loading="popupLoading">
    <div slot="body">
      <el-form
        class="dataForm"
        ref="form"
        :disabled="disabled"
        :model="formParameter"
        :inline="true"
        label-width="80px"
        :rules="rules"
      >
        <el-row>
         <el-col :span="24"  v-if="type==1">
            <el-form-item  v-if="wrptxt" label="周报内容"  >
                  <div v-html="formParameter.wrptxt"  class="content-html"></div>
            </el-form-item>
            <hr>
          </el-col>
          <el-col :span="24" v-if="type!=1">
              <el-form-item  v-if="wrptxt" label="修改前"  >
                  <div  v-html="wrptxt" class="content-html"></div>
            </el-form-item>
            <el-form-item label="周报内容" prop="wrptxt">
              <wang-edit 
                :disable="disabled"
                 v-model="formParameter.wrptxt"
                  :isupdt ="isUpdtWedit"
              ></wang-edit>
            </el-form-item>
             <hr>
          </el-col>
       
        </el-row>
     <el-row  v-if="formParameter.sptm">
          <el-col :span="4">
             <el-form-item label="审批时间" prop="sptxt">
                 {{formParameter.sptm}}
            </el-form-item>
               </el-col>
               <el-col :span="4">
             <el-form-item label="审批人:" prop="sptxt">
                  {{formParameter.sper}}
            </el-form-item>
              </el-col>
               <el-col :span="4">
             <el-form-item label="审批结果:" prop="sptxt">
                 <el-tag type="success" v-if="formParameter.state == 1">已审批</el-tag>
                 <el-tag type="warning" v-if="formParameter.state == 0">待审批</el-tag>
                 <el-tag type="danger" v-if="formParameter.state == 2">需修改</el-tag>
            </el-form-item>
              </el-col>
               <el-col :span="12">
             <el-form-item label="意见:" prop="sptxt">
                    {{formParameter.sptxt}}
            </el-form-item>
      
          </el-col>
        </el-row>
        <el-row v-if="formParameter.sptm">
          <el-col :span="24">
               <hr>
          </el-col>
        </el-row>
        <el-row v-if="achivementTypes">
          <el-col :span="24">
            <el-form-item label="工作业绩" prop="wrpt">
              <el-button
                type="primary"
                size="small"
                v-if="!disabled"
                @click="dialogFormVisible = true">添加业绩+工作量</el-button
              >
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="18" :offset="3">
            <el-table :data="formParameter.wkrptachiList" style="width: 100%">
              <el-table-column prop="wrptyjendday" label="业绩时间" width="110">
              </el-table-column>
              <el-table-column prop="pnm" label="业绩名称" width="110">
              </el-table-column>
              <el-table-column prop="cnt" label="业绩值" width="80">
              </el-table-column>
              <el-table-column prop="remarks" label="业绩备注">
              </el-table-column>
              <el-table-column
                label="操作"
                v-if="!disabled"
                fixed="right"
                ignored
              >
                <template slot-scope="scope">
                  <div class="dataTable-operator">
                    <el-button type="text" @click="deletechive(scope.row)"
                      >删除</el-button
                    >
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-form>
      <el-dialog
        title="添加个人本周业绩+工作量"
        :visible.sync="dialogFormVisible"
        :modal="false"
      >
        <el-form :model="achivement">
          <el-form-item
            label="业绩名称"
            :label-width="formLabelWidth"
            prop="pnm"
          >
            <el-select v-model="achivement.pnm" placeholder="请选择业绩类型">
              <el-option
                v-for="item in achivementTypes"
                :key="item.nm"
                :label="item.rmk"
                :value="item.nm"
              >
              </el-option>
            </el-select>
          </el-form-item>
         <el-form-item label="完成时间" :label-width="formLabelWidth"  >
             <el-date-picker 
               v-model="achivement.edy"
               type="date"
               placeholder="跨月周需选择业绩时间">
    </el-date-picker>
          </el-form-item>
          <el-form-item label="业绩值" :label-width="formLabelWidth">
            <el-input v-model="achivement.cnt" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="业绩备注" :label-width="formLabelWidth">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 4 }"
              v-model="achivement.remarks"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="addachive">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog
        :title="spAdv.title"
        :visible.sync="spAdv.spdialogVisible"
        :modal="false"
      >
        <el-form :model="spAdv">
          <el-form-item
            label="审批结果:"
            :label-width="formLabelWidth"
            prop="state"
          >
            <el-radio v-model="spAdv.state" label="1">同意并认同</el-radio>
            <el-radio v-model="spAdv.state" label="2">需修改</el-radio>
          </el-form-item>

          <el-form-item
            label="审批意见"
            :label-width="formLabelWidth"
            prop="sptxt" >
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 4 }"
              v-model="spAdv.sptxt"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="spAdv.spdialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="addSp">审 批</el-button>
        </div>
      </el-dialog>
    </div>
    <div slot="footer">
      <el-button
        v-if="!disabled"
        type="primary"
        :loading="confirmLoading"
        @click="confirm"
        >确 定</el-button
      >
      <el-button
        v-if="
          formParameter.state == 0 &&
          (me.role2 == 'admin' ||
            me.role2 == 'admin2' ||
            me.role2 == 'mgr' ||
            me.role2 == 'mgr2' ||
            me.role2 == 'mgr3') && (!formParameter.type  )
        "
        @click="toSp"
        >审 批</el-button
      >
      <el-button @click="close">关 闭</el-button>
    </div>
  </popup>
</template>

<script>
import popup from "@/components/popup/drawerPopup.vue";
import api from "@/api/oa/wkreport.js";
import apiRole from "@/api/system/role/role.js";
import selectOptionDictionary from "@/components/biz/selectOptionDictionary/selectOptionDictionary.vue";
import wangEdit from "@/components/wangEdit/wangEdit.vue";

export default {
  name: "edit",
  components: {
    popup,
    selectOptionDictionary,
    wangEdit
  },
  data() {
    return {
      disabled: false,
      popupLoading: false,
      confirmLoading: false,
      dialogFormVisible: false,
      parameter: {},
      formParameter: {},
      form: {},
      achivement: {},
      formLabelWidth: "120px",
      achivementTypes: false,
      minNow:"",
      maxNow:"",
      me: {},
      wrptxt:false,
      rules: {},
      spAdv: {},
      type:1,

      isUpdtWedit:false   //用于更新wangEdit
    };
  },

  methods: {
    toSp() {
      this.spAdv = {
        spdialogVisible: true,
        state: "1",
        sptxt: "",
        title: "审批周报",
      };
    },
    addSp() {
      api.sp(
        {
          id: this.formParameter.id,
          state: this.spAdv.state,
          sptxt: this.spAdv.sptxt,
        },
        (res) => {
          this.$utils.msg.success(res.msg);
          this.confirmLoading = false;
          this.spCmit = true;
          this.spAdv.spdialogVisible = false;
          this.close();
          this.$emit("flush");
        },
        (res) => {
          this.$utils.msg.warning(response.msg);
          this.confirmLoading = false;
        }
      );
    },
    //删除业绩
    deletechive(row) {
       let rowdel ;
       for (let i = 0; i < this.formParameter.wkrptachiList.length; i++) {
            rowdel =   this.formParameter.wkrptachiList[i]
            if( row.wrptyjendday ==  rowdel.wrptyjendday && row.pnm ==  rowdel.pnm 
                 && row.cnt ==  rowdel.cnt && row.remarks ==  rowdel.remarks ){
                  this.formParameter.wkrptachiList.splice(i, 1);
                return true
            }
       }
    },
    //添加业绩
    addachive() {

     if (  (!this.achivement.pnm) && this.achivement.pnm.length==0) {
        this.$utils.msg.warning("业绩名称必选");
        return;
      }

      if ( isNaN( this.achivement.cnt) ) {
        this.$utils.msg.warning("业绩必须是数值");
        this.achivement.cnt=""
        return;
      }

      if (!this.formParameter.wkrptachiList) {
        this.formParameter.wkrptachiList = [];
      }

       if (this.achivement.edy) {
           this.achivement.wrptyjendday = new Date(this.achivement.edy.getTime()+8*3600000 ).format("yyyy-MM-dd")
           delete this.achivement.edy
       }

      this.formParameter.wkrptachiList.push(this.achivement);
      this.dialogFormVisible = false;
      this.achivement = {};
    },

    //打开弹框
    open(row, me,type, title, disabled, size) {

      this.me = me;
      this.type = type
      this.formParameter = row;
      this.wrptxt =false
      if(  this.formParameter.wrptxt ){
      
          this.isUpdtWedit = true
          setTimeout(()=>{
            this.isUpdtWedit = false
          },100)

          this.wrptxt = this.formParameter.wrptxt

      } 

      this.disabled = disabled;

      if("填写上周周报" == title  || "填写本周周报" == title){

          if("填写上周周报" == title){
            this.formParameter.type=-1
          }else{
            this.formParameter.type=0
          }

          //校验能不能填
          api.isCanRpt({eid:me.id,type: this.formParameter.type  },res=>{
              if(res.data){
                 apiRole.jxfn({ rcode: this.me.role2 }, (res) => {
                     if (res.msg && res.msg.length > 2) {
                         this.achivementTypes = JSON.parse(res.msg);
                    }
                 this.$refs.popup.open(title, size);
                 }); 
              }else{
                       this.$alert( this.formParameter.type=-1?"上周周报已提交":"本周周报已提交"  ,  "无需填报,每周只需填写一个周报。", {
                          confirmButtonText: "确定",
                          callback: (action) => { },
                        });
               }
          })
          return
      }else if("编辑" == title.substring(0,2)){
         this.formParameter.type=1
      }else{
         delete this.formParameter.type
      }

    apiRole.jxfn({ rcode: this.me.role2 }, (res) => {
        if (res.msg && res.msg.length > 2) {
          this.achivementTypes = JSON.parse(res.msg);
        }

        this.$refs.popup.open(title, size);
      });

      


    },
    //关闭弹框
    close() {
      this.disabled = false;    
      this.formParameter = {}
      this.achivement={}
      this.$emit("flush");
      this.$refs.popup.close();
    
    },
    //提交表单
    confirm() {
    
      this.confirmLoading = true;

          //添加+修改
          let parameter = this.$utils.merger(this.formParameter);
    
          api.merge(
            parameter,
            (response) => {
              this.$utils.msg.success(response.msg);
              this.confirmLoading = false;
              this.close();
              this.$parent.list();
            },
            (response) => {
              this.$utils.msg.warning(response.msg);
              this.confirmLoading = false;
            }
          );

    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";
 
.content-html {
  border: 1px solid #c9d8db !important;
  padding: 4px;
}

</style>
